import { ObjectSchema, number, object, string } from "yup";

// ------------- FILTER PRODUCT -------------
export type FilterProduct = {
  search?: string;
  category?: string;
  merchant?: string;
};

export const filterProductSchema: ObjectSchema<FilterProduct> = object({
  search: string().optional(),
  category: string().optional(),
  merchant: string().optional(),
});
// ------------- FILTER PRODUCT -------------

// ------------- FILTER PRODUCT -------------
export type Checkout = {
  pin: string;
  amount: number;
  paymentMethod: string;
  paymentFee: number;
};

export const checkoutSchema: ObjectSchema<Checkout> = object({
  amount: number().required(),
  pin: string().max(6).min(6).required(),
  paymentMethod: string().required(),
  paymentFee: number().required(),
});
// ------------- FILTER PRODUCT -------------

// ------------- FILTER PRODUCT -------------
export type CreatePin = {
  newPin: string;
  confirmPin: string;
};

export const createPinSchema: ObjectSchema<CreatePin> = object({
  newPin: string().max(6).min(6).required(),
  confirmPin: string().max(6).min(6).required(),
});
// ------------- FILTER PRODUCT -------------
